<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.BusinessUnit">Business Unit</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field matTooltip="Business Unit Id" [matTooltipDisabled]="disabledTooltip(this.buId)">
          <mat-label i18n="@@type.BusinessUnit.buId">Business Unit Id</mat-label>
          <input matInput formControlName="buId" id="buIdFilterInput"              
              (ngModelChange)="buIdChanging($event)" [(ngModel)]="buIdFilter"              
              (ngModelChange)="buIdChanged($event)" #buIdFilterInput              
              maxlength="6" placeholder="Business Unit Id">
        </mat-form-field>  

        <mat-form-field matTooltip="Name" [matTooltipDisabled]="disabledTooltip(this.name)">
          <mat-label i18n="@@type.BusinessUnit.name">Name</mat-label>
          <input matInput formControlName="name" id="nameFilterInput"              
              (ngModelChange)="nameChanging($event)" [(ngModel)]="nameFilter"              
              (ngModelChange)="nameChanged($event)" #nameFilterInput              
              maxlength="40" placeholder="Name">
        </mat-form-field>  

        <mat-form-field matTooltip="Acronym" [matTooltipDisabled]="disabledTooltip(this.acronym)">
          <mat-label i18n="@@type.BusinessUnit.acronym">Acronym</mat-label>
          <input matInput formControlName="acronym" id="acronymFilterInput"              
              (ngModelChange)="acronymChanging($event)" [(ngModel)]="acronymFilter"              
              (ngModelChange)="acronymChanged($event)" #acronymFilterInput              
              maxlength="6" placeholder="Acronym">
        </mat-form-field>  

        <mat-form-field matTooltip="Select a Type from the list" [matTooltipDisabled]="disabledTooltip(this.type)">
          <mat-label i18n="@@type.BusinessUnit.type">Type</mat-label>
          <mat-select formControlName="type" id="typeFilterInput"              
              (ngModelChange)="typeChanging($event)" [(ngModel)]="typeFilter"              
              (ngModelChange)="typeChanged($event)" #typeFilterInput              
              placeholder="Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let type of typeSelectionList" [value]="type.code">
              {{type.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>  

        <mat-form-field matTooltip="Select a Closed from the list" [matTooltipDisabled]="disabledTooltip(this.closed)">
          <mat-label i18n="@@type.BusinessUnit.closed">Closed</mat-label>
          <mat-select formControlName="closed" id="closedFilterInput"              
              (ngModelChange)="closedChanging($event)" [(ngModel)]="closedFilter"              
              (ngModelChange)="closedChanged($event)" #closedFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>  

		<mat-slide-toggle floatLabel="always" appearance="none" color="primary"  *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch"  [ngModelOptions]="{standalone: true}">
            Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>
		  

        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>
			
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="buId">
            <mat-header-cell [crud-column-header]="columns.column('buId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.BusinessUnit.buId">
                Business Unit Id
              </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.buId}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="acronym">
            <mat-header-cell [crud-column-header]="columns.column('acronym')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnit.acronym">
                Acronym 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.acronym}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="closed">
            <mat-header-cell [crud-column-header]="columns.column('closed')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-tiny" i18n="@@type.BusinessUnit.closed">
                Closed 
              </mat-header-cell>
            <mat-cell class="search-column-tiny" *matCellDef="let element">
              <mat-icon *ngIf="element.closed">check_box</mat-icon><mat-icon *ngIf="!element.closed">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="name">
            <mat-header-cell [crud-column-header]="columns.column('name')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-medium" i18n="@@type.BusinessUnit.name">
                Name 
              </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{element.name}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="territorial">
            <mat-header-cell [crud-column-header]="columns.column('territorial')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnit.territorial">
                Territorial 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.territorial">check_box</mat-icon><mat-icon *ngIf="!element.territorial">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="territory">
            <mat-header-cell [crud-column-header]="columns.column('territory')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnit.territory">
                Territory 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.territory}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="type">
            <mat-header-cell [crud-column-header]="columns.column('type')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnit.type">
                Type 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.type | refDecode:'BU_TYPE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary" [routerLink]="createRoute()"
        [queryParams]="createRouteQueryParams()" i18n="@@actions.create" id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>